module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Warrior.c02c22b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Warrior.jpg
// module id = pLLv
// module chunks = 0